import { Constants } from './@shared/constants/app.constants';

import { StorageItem } from './@core/utils/local-storage.utils';
import {
  Component,
  ViewEncapsulation,
  Inject,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { SidebarComponent } from '@syncfusion/ej2-angular-navigations';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  EventMessage,
  EventType,
  InteractionType,
  PopupRequest,
  RedirectRequest,
} from '@azure/msal-browser';
import { HttpClient } from '@angular/common/http';
import { MenuItemModel } from '@syncfusion/ej2-navigations';
import { NavigationEnd, Router } from '@angular/router';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { UserService } from './services/user.service';
import { Employee } from './models/wizard.model';
import { REVIEW_TABS } from './review/constants/review.constants';
import { UserDetails } from './@shared/models';
import { UserDetailsService } from './@shared/services';
import { setItem } from './@core/utils';
import { getFormattedDate } from './@core/utils/date-format.utils';
import { UrlService } from './helper/services/url.service';
import { environment } from 'src/environments/environment';

export interface CustomMenuItem extends MenuItemModel {
  _url: string;
  queryparam?: any;
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'JobNet';
  profile: any;
  currentUser!: Employee;
  companyLogo: any;
  constants = Constants;
  previousUrl: string = null;
  currentUrl: string = null;

  @ViewChild('sidebarMenuInstance')
  public sidebarMenuInstance!: SidebarComponent;
  public width = '160px';
  public mediaQuery = '(min-width: 600px)';
  public target = '.main-content';
  public dockSize = '50px';
  public enableDock = true;
  public res: any;
  @ViewChild('sidebar')
  public sidebar!: SidebarComponent;

  isIframe = false;
  loggedIn = false;

  public menuItems: CustomMenuItem[] = [
    {
      text: 'Job Scheduling',
      iconCss: 'icon-globe icon',
      _url: '/Scheduler',
      items: [],
    },
    {
      text: 'Time Card Review',
      iconCss: 'icon-timecard icon',
      _url: `Review/${REVIEW_TABS.EMPLOYEE}`,
      queryparam: { date: getFormattedDate(new Date()) },
      items: [],
    },
    // {
    //   text: 'Profile',
    //   iconCss: 'icon-user icon',
    //   items: [],
    // },
  ];
  public AccountMenuItem: MenuItemModel[] = [
    {
      text: '',
      items: [{ text: 'Profile' }, { text: 'Sign out' }],
    },
  ];

  // tslint:disable-next-line: variable-name
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    private router: Router,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private userService: UserService,
    private userDetails: UserDetailsService,
    private urlService: UrlService
  ) {}

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;

    this.checkAccount();
    if (this.loggedIn) {
      this.getProfile();
    }
    this.loginGetMsalSubject();
    this.setUrlServiceData();
    this.router.navigate(['/Review/Employee'], {
      queryParams: { date: getFormattedDate(new Date()) },
    });
  }

  setUrlServiceData(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.urlService.setPreviousUrl(this.previousUrl);
      });
  }

  onMenuItemSelect(event: any): void {
    if (event.item.queryparam) {
      this.router.navigate([event.item._url], {
        queryParams: event.item.queryparam,
      });
    } else {
      if(event.item._url === '/Scheduler'){
        window.location.href = environment.jobScheduleRedirect
      }else{
        this.router.navigate([event.item._url]);
      }
    }
  }

  getProfile(): void {
    this.http
      .get('https://graph.microsoft.com/v1.0/me')
      .toPromise()
      .then((profile: any) => {
        this.profile = profile;
      });
    this.getCurrentUser();
  }
  checkAccount(): void {
    this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
    this.getUserDetails();
  }

  login(): void {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService
          .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe(() => this.checkAccount());
      } else {
        this.authService.loginPopup().subscribe(() => this.checkAccount());
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({
          ...this.msalGuardConfig.authRequest,
        } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  logout(): void {
    this.authService.logout();
  }

  // unsubscribe to events when component is destroyed

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  // open new tab
  newTabClick(): void {
    const URL = location.href.replace(location.search, '');
    document
      .getElementById('newTab')
      ?.setAttribute('href', URL.split('#')[0] + 'sidebar/sidebar-menu');
  }

  // tslint:disable-next-line: typedef
  openClick() {
    this.sidebarMenuInstance.toggle();
  }

  public loadRoutingContent(args: any): void {
    // const data: any = this.tree.getTreeData(args.node);
    if (args.item.text === 'Sign out') {
      this.authService.logout();
    }
    if (args.item.text === 'Profile') {
      this.router.navigate(['/Profile']);
    }
  }

  getCurrentUser(): void {
    this.userService.GetCurrentUser().subscribe(
      (responsesData: { body: Employee }) => {
        if (this.sidebarMenuInstance != null) {
          this.sidebarMenuInstance.hide();
        }
        if (
          isNullOrUndefined(this.currentUser) ||
          this.currentUser.companyId <= 0
        ) {
          this.companyLogo = '../assets/images/2.png';
        } else {
          this.companyLogo =
            '../assets/images/' + this.currentUser.companyId + '.png';
        }
      },
      (error: any) => {
        console.log(error);
        this.router.navigate(['/401']);
      }
    );
  }

  loginGetMsalSubject(): void {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS ||
            msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result: any) => {
        this.checkAccount();
      });
  }

  getUserDetails(): void {
    if (!this.loggedIn) {
      return;
    }
    this.userDetails.getUserDetails().subscribe((user: UserDetails) => {
      if (user) {
        this.userDetails.setUser(user);
        setItem(StorageItem.userEmail, user.userPrincipalName);
      }
    });
  }
}
